import { useState } from 'react';
import { MessageCircle, X, Mail, HelpCircle, Lightbulb } from 'lucide-react';

const FloatingSupportButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleEmailSupport = (type) => {
    const isFeature = type === 'suggestion';
    const subject = encodeURIComponent(isFeature ? 'MovieBot Feature Suggestion' : 'MovieBot Support Request');
    const body = encodeURIComponent(isFeature ? `Hi MovieBot Team,

I have a suggestion for MovieBot:

[Please describe your idea or feature suggestion here]

---
Page URL: ${window.location.href}
` : `Hi MovieBot Team,

I need help with:

[Please describe your issue or question here]

---
Page URL: ${window.location.href}
`);
    window.location.href = `mailto:admin@moviebot.net?subject=${subject}&body=${body}`;
    setIsOpen(false);
  };

  return (
    <>
      {/* Popup Panel */}
      {isOpen && (
        <div className="fixed bottom-24 left-6 w-80 bg-secondary border border-white/10 shadow-2xl rounded-lg z-[9999]">
          {/* Header */}
          <div className="bg-primary/20 p-4 border-b border-white/10">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <HelpCircle className="w-5 h-5 text-primary" />
                <h3 className="font-bold text-white">We'd Love to Hear From You</h3>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-muted-foreground hover:text-white transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="p-4 space-y-3">
            <p className="text-sm text-muted-foreground">
              Running into an issue or have an idea to make MovieBot even better? Let us know!
            </p>

            {/* Support Option */}
            <button
              onClick={() => handleEmailSupport('support')}
              className="w-full p-3 bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/30 hover:border-blue-500/50 transition-all flex items-center gap-3 group rounded-md"
              data-testid="email-support-btn"
            >
              <div className="w-10 h-10 bg-blue-500/20 flex items-center justify-center group-hover:bg-blue-500/30 transition-colors rounded-md">
                <Mail className="w-5 h-5 text-blue-400" />
              </div>
              <div className="text-left">
                <p className="text-white font-medium text-sm">Get Help</p>
                <p className="text-xs text-muted-foreground">Having an issue? We'll help you out</p>
              </div>
            </button>

            {/* Suggestion Option */}
            <button
              onClick={() => handleEmailSupport('suggestion')}
              className="w-full p-3 bg-primary/10 hover:bg-primary/20 border border-primary/30 hover:border-primary/50 transition-all flex items-center gap-3 group rounded-md"
              data-testid="email-suggestion-btn"
            >
              <div className="w-10 h-10 bg-primary/20 flex items-center justify-center group-hover:bg-primary/30 transition-colors rounded-md">
                <Lightbulb className="w-5 h-5 text-primary" />
              </div>
              <div className="text-left">
                <p className="text-white font-medium text-sm">Share a Suggestion</p>
                <p className="text-xs text-muted-foreground">Have an idea? We'd love to hear it!</p>
              </div>
            </button>

            <p className="text-xs text-center text-muted-foreground pt-2">
              We typically respond within 24 hours
            </p>
          </div>
        </div>
      )}

      {/* Floating Button - Now on the LEFT side */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed bottom-6 left-6 z-[9999] w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all ${
          isOpen 
            ? 'bg-white/20 text-white' 
            : 'bg-primary text-black hover:bg-primary/90'
        }`}
        data-testid="floating-support-btn"
      >
        {isOpen ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
      </button>
    </>
  );
};

export default FloatingSupportButton;
